<!--
 * @Author: AnNa
 * @Date: 2021-08-10 09:19:09
 * @LastEditors: AnNa
 * @LastEditTime: 2021-08-13 16:24:15
 * @Description:
-->

<template>
  <page-view>
    <div slot="headerContent">
      <search-robot @changeRobotId="onChangeRobotId"></search-robot>
    </div>
    <a-card :bordered="false">
      <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }" @submit="handleSubmit">
        <a-divider :dashed="true" orientation="left">朋友圈配置</a-divider>
        <a-form-item label="是否跟发官方朋友圈" help="此开关的开启或关闭，需要重启客户端软件才能生效哦~">
          <a-switch v-decorator="['follow_official', { valuePropName: 'checked' }]" />
        </a-form-item>
        <a-form-item label="完全跟发" help="开启后跟发好友，好友发啥机器人发啥，不做任何转换">
          <a-switch v-decorator="['full_flooding', { valuePropName: 'checked' }]" />
        </a-form-item>

        <a-form-item label="是否绑定朋友圈订单" help="关闭此开关后，朋友圈订单不再支持绑定返利，发订单号也不支持绑定哦~">
          <a-switch v-decorator="['bind_pyq_order', { valuePropName: 'checked' }]" />
        </a-form-item>

        <!-- <a-form-item v-if="!form.getFieldValue('bind_pyq_order')" label="查券后支持绑定"> -->
        <a-form-item label="查券后支持绑定">
          <a-switch v-decorator="['circle_order_bind_switch', { valuePropName: 'checked' }]" />
        </a-form-item>

        <a-form-item label="跟发好友微信" help="请输入好友的微信ID,跟发模式下,只转口令(可在插件-查券设置自定义口令识别符),不转中间页,请您知悉">
          <a-tag :style="{ marginLeft: '10px' }"
            @click="$refs.selectFansModal.show({ robotid: currentRobotId })">选择微信</a-tag>
          <div class="ant-form-explain">
            此处获取的是会员列表，如果找不到要跟发的好友，可以让好友给机器人发签到，即可注册会员，也可以到通讯录列表手动复制wxid填写哦!
          </div>
          <a-input v-decorator="['follow_friend']" />
        </a-form-item>
        <a-form-item label="跟发好友使用评论模板">
          <a-select v-model="templateTitle" placeholder="请选择" @select="selectTemplate">
            <a-select-option value="-1">不使用</a-select-option>
            <a-select-option v-for="item in templateList" :key="`${item.id}#split#${item.comment_text}`">
              {{ item.comment_title }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="发圈间隔时间(分钟)" help="推荐30-60分钟，请不要设置为空!">
          <a-input-number :min="0" :max="3600" placeholder="最小值" v-decorator="['send_step_gt', { initialValue: 1 }]" />-
          <a-input-number :min="0" :max="3600" placeholder="最大值" v-decorator="['send_step_lt', { initialValue: 1 }]" />
        </a-form-item>
        <a-form-item label="发圈时间">
          <a-time-picker disabled v-decorator="['active_time_start']" />
          <span :style="{ display: 'inline-block', width: '24px', textAlign: 'center' }"> - </span>
          <a-time-picker disabled v-decorator="['active_time_end']" />
        </a-form-item>
        <a-form-item label="未识别表情设置">
          <a-radio-group v-decorator="['wsbEmote', { initialValue: 1 }]">
            <a-radio :value="0">未识别表情自动替换</a-radio>
            <a-radio :value="1">未识别表情自动隐藏</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="过滤关键词" help="多个关键词用英文逗号隔开">
          <a-input placeholder="过滤词1,过滤词2" v-decorator="['filter_keywords']"></a-input>
        </a-form-item>
        <a-form-item label="推送到">
          <robot-multiple v-decorator="['robotids', { rules: [{ required: true, message: '必填项' }] }]"></robot-multiple>
        </a-form-item>
        <div style="text-align: center">
          <a-button type="primary" @click="handleSubmit">推送设置</a-button>
        </div>
      </a-form>
      <select-fans-modal ref="selectFansModal" @change="onChangeFans"></select-fans-modal>
    </a-card>
  </page-view>
</template>
<script>
import { queryConfigOfPyq, saveConfigOfPyq, queryListOfMessage } from '@/api/pyq'
import { PageView } from '@/layouts'
import SearchRobot from '@/views/components/SearchRobot'
import RobotMultiple from '@/views/components/RobotMultiple'
import SelectFansModal from '@/views/components/SelectFansModal'
import moment from 'moment'
import { mapActions } from 'vuex'
export default {
  data() {
    return {
      form: this.$form.createForm(this),
      autoT: false,
      loading: false,
      cfg: null,
      deviceInfo: null,
      treeData: [],
      userTree: [],
      currentRobotId: null,
      templateTitle: '-1',
      templateList: [],
      templateActiveObj: {},
    }
  },
  components: {
    PageView,
    SearchRobot,
    SelectFansModal,
    RobotMultiple
  },

  methods: {
    ...mapActions(['BatchpushTask', 'TaskDrawerSwitch']),
    selectTemplate(value) {
      if (-1 === Number(value)) {
        value += '#split#'
      }
      var arr = value.split('#split#')
      this.templateActiveObj = {
        circle_template_id: arr[0],
        circle_template_content: arr[1]
      }
    },
    setDevice(record) {
      this.deviceInfo = record[0]
      this.getData()
    },

    onChangeRobotId(id) {
      this.currentRobotId = id
      this.getData()
    },
    onSelect(selectedKeys, info) {
      // console.log('selected', selectedKeys, info)
    },
    onCheck(checkedKeys, info) {
      // console.log('onCheck', checkedKeys, info)
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        // console.log('values=', values)
        if (!err) {
          values.active_time_start = moment(values.active_time_start).format('HH:mm:ss')
          values.active_time_end = moment(values.active_time_end).format('HH:mm:ss')
          values.circle_template_id = Number(this.templateActiveObj.circle_template_id) || -1
          values.circle_template_content = this.templateActiveObj.circle_template_content || '',
            this.BatchpushTask({
              robotids: values.robotids,
              descs: '朋友圈推送',
              apiFun: sub_id => {
                return saveConfigOfPyq({ ...values, sub_id })
              }
            })
          this.TaskDrawerSwitch({ status: true })
          this.form.resetFields('robotids')
        }
      })
    },
    onChangeFans(data) {
      let wwid = data.wwid
      wwid = wwid.replace(/-/g, 'p')
      wwid = wwid.replace(/\*/g, 'o')
      wwid = wwid.replace(/&/g, 'i')
      wwid = wwid.replace(/\^/g, 'u')
      this.form.setFieldsValue({
        follow_friend: window.atob(wwid)
      })
      this.$refs.selectFansModal.handleCancel()
    },
    getData() {
      queryConfigOfPyq({
        sub_id: this.currentRobotId
      }).then(res => {
        const data = res.data
        if (data.follow_template) {
          const flag = this.templateList.findIndex((item) => {
            return Number(item.id) === Number(data.follow_template.id)
          })
          if (flag != -1 && Number(data.follow_template?.id) != -1) {
            const resTitle = this.templateList.filter((item) => {
              return item.id == data.follow_template.id
            })
            this.templateTitle = resTitle[0].comment_title
            this.templateActiveObj = {
              circle_template_id: data.follow_template?.id,
              circle_template_content: data.follow_template?.content
            }
          } else {
            this.templateTitle = '不使用'
          }
        }
        // console.log('功能设置-data=', data)
        this.form.setFieldsValue({
          follow_official: data.follow_official,
          active_time_end: data.active_time_end ? moment(data.active_time_end, 'HH:mm:ss') : null,
          active_time_start: data.active_time_start ? moment(data.active_time_start, 'HH:mm:ss') : null,
          send_step_lt: data.send_step_lt,
          send_step_gt: data.send_step_gt,
          follow_friend: data.follow_friend,
          bind_pyq_order: data.bind_pyq_order,
          circle_order_bind_switch: data.circle_order_bind_switch,
          full_flooding: data.full_flooding ? data.full_flooding : false,
          filter_keywords: data.filter_keywords,
          wsbEmote: data.wsbEmote // 未识别表情设置
        })
      })
    },
    copyText(text) {
      var input = document.createElement('input')
      input.setAttribute('readonly', 'readonly')
      input.setAttribute('value', text)
      document.body.appendChild(input)
      input.select()
      input.setSelectionRange(0, 9999)
      document.execCommand('Copy')
      if (document.execCommand('Copy')) {
        this.$message.success('复制成功')
        input.setAttribute('style', 'display: none')
      }
    }
  },
  created() {
    queryListOfMessage({}).then(res => {
      this.templateList = res.data
    })
  }
}
</script>
